import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 3264.000000 3264.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,3264.000000) scale(0.100000,-0.100000)" >
<path d="M16155 20520 c-33 -4 -148 -9 -255 -9 -191 -2 -440 -12 -750 -32 -85
-5 -222 -12 -305 -15 -82 -3 -154 -10 -160 -15 -5 -5 -41 -9 -80 -9 -38 0 -90
-5 -115 -11 -43 -10 -129 -20 -340 -39 -52 -5 -138 -13 -191 -18 -53 -5 -101
-12 -107 -16 -7 -4 -45 -12 -85 -17 -248 -34 -317 -45 -343 -53 -20 -6 -88
-17 -224 -36 -116 -16 -184 -28 -255 -45 -38 -9 -94 -21 -122 -26 -133 -23
-162 -29 -223 -44 -36 -10 -82 -19 -103 -22 -20 -3 -40 -9 -43 -14 -3 -5 -23
-9 -45 -9 -21 0 -47 -4 -57 -10 -19 -10 -97 -29 -155 -37 -20 -3 -40 -9 -43
-14 -3 -5 -23 -9 -45 -9 -21 0 -39 -4 -39 -8 0 -8 -77 -29 -143 -39 -20 -3
-40 -9 -43 -14 -3 -5 -21 -9 -40 -9 -19 0 -34 -4 -34 -10 0 -5 -10 -10 -21
-10 -22 0 -110 -26 -141 -41 -10 -5 -29 -9 -43 -9 -14 0 -33 -4 -43 -9 -9 -5
-57 -21 -107 -36 -49 -15 -99 -31 -110 -35 -77 -28 -93 -33 -118 -37 -15 -3
-30 -9 -33 -14 -3 -5 -18 -9 -33 -9 -15 0 -31 -4 -36 -8 -6 -4 -35 -16 -65
-26 -30 -11 -59 -23 -65 -27 -5 -5 -19 -9 -31 -9 -13 0 -26 -4 -29 -10 -3 -5
-17 -10 -30 -10 -13 0 -26 -4 -30 -9 -3 -5 -20 -13 -37 -17 -31 -6 -40 -10
-88 -34 -11 -5 -29 -10 -39 -10 -11 0 -22 -4 -25 -9 -3 -4 -27 -16 -53 -25
-26 -10 -57 -21 -68 -26 -30 -12 -97 -40 -125 -52 -14 -6 -34 -14 -45 -18 -23
-9 -132 -58 -157 -71 -10 -5 -25 -9 -33 -9 -8 0 -15 -4 -15 -10 0 -5 -6 -10
-14 -10 -7 0 -34 -11 -60 -25 -26 -14 -53 -25 -61 -25 -7 0 -15 -3 -17 -7 -1
-5 -28 -20 -58 -35 -167 -80 -273 -133 -335 -168 -38 -21 -95 -51 -125 -67
-30 -15 -61 -33 -67 -39 -7 -7 -26 -18 -43 -26 -16 -7 -30 -16 -30 -20 0 -5
-9 -8 -19 -8 -11 0 -21 -3 -23 -7 -3 -8 -84 -63 -92 -63 -10 0 -379 -252 -396
-270 -3 -3 -30 -23 -60 -44 -30 -22 -56 -43 -58 -48 -2 -4 -8 -8 -14 -8 -5 0
-15 -6 -22 -13 -8 -7 -37 -33 -66 -58 -29 -24 -58 -50 -66 -56 -7 -7 -15 -13
-17 -13 -5 0 -125 -112 -232 -217 -71 -69 -201 -210 -251 -273 -16 -19 -31
-37 -34 -40 -3 -3 -18 -23 -35 -45 -16 -22 -32 -42 -35 -45 -16 -13 -125 -178
-180 -270 -52 -88 -133 -248 -172 -340 -6 -14 -14 -33 -19 -42 -5 -10 -9 -27
-9 -38 0 -11 -4 -28 -9 -38 -25 -49 -41 -95 -41 -117 0 -13 -4 -26 -9 -29 -5
-3 -11 -23 -14 -43 -12 -81 -26 -160 -36 -212 -6 -29 -11 -80 -11 -112 0 -31
-5 -80 -12 -108 -9 -38 -9 -74 0 -148 7 -54 14 -125 17 -158 6 -69 23 -167 36
-211 5 -17 9 -42 9 -57 0 -14 4 -28 9 -31 5 -3 11 -20 13 -38 5 -33 42 -147
59 -180 5 -10 9 -22 9 -27 0 -18 118 -258 171 -347 64 -109 168 -262 224 -329
22 -27 54 -68 70 -90 69 -94 402 -427 516 -517 19 -14 45 -36 59 -48 14 -13
50 -41 80 -64 30 -22 57 -44 60 -47 3 -3 39 -30 80 -59 41 -29 81 -59 88 -66
7 -7 30 -23 52 -35 22 -13 40 -26 40 -31 0 -4 5 -8 11 -8 6 0 39 -20 73 -45
35 -25 67 -45 70 -45 4 0 22 -11 40 -25 18 -14 36 -25 40 -25 4 0 32 -16 62
-35 30 -19 59 -35 64 -35 6 0 10 -3 10 -7 0 -5 10 -13 23 -19 68 -33 182 -98
185 -105 2 -5 12 -9 22 -9 10 0 20 -3 22 -8 3 -6 385 -199 468 -235 19 -8 62
-27 95 -42 78 -35 195 -85 220 -95 18 -7 56 -23 125 -52 14 -6 33 -14 42 -19
10 -5 22 -9 28 -9 6 0 33 -11 62 -25 28 -14 60 -25 69 -25 10 0 21 -4 24 -10
3 -5 15 -10 26 -10 10 0 27 -4 37 -9 9 -5 37 -17 62 -26 25 -9 53 -21 62 -26
10 -5 25 -9 33 -9 8 0 23 -4 33 -9 46 -23 95 -41 112 -41 10 0 22 -4 25 -10 3
-5 19 -10 35 -10 16 0 31 -3 34 -8 2 -4 36 -16 75 -27 39 -10 71 -23 71 -27 0
-4 13 -8 29 -8 17 0 33 -4 36 -10 3 -5 18 -10 33 -10 15 -1 38 -7 52 -15 14
-8 37 -14 53 -15 15 0 27 -4 27 -9 0 -5 17 -11 38 -14 36 -5 49 -8 162 -42 30
-9 66 -19 80 -22 14 -2 34 -8 45 -13 11 -5 34 -11 50 -14 17 -2 57 -12 90 -21
68 -19 121 -32 180 -45 22 -5 69 -16 105 -25 36 -9 83 -19 105 -22 22 -3 44
-9 50 -14 5 -5 22 -9 39 -9 16 0 43 -4 60 -9 62 -18 172 -41 196 -41 15 0 30
-4 35 -9 6 -5 30 -11 55 -14 25 -3 79 -13 120 -22 83 -18 152 -29 405 -64 39
-5 83 -14 98 -20 16 -6 50 -11 76 -11 26 0 51 -4 56 -9 6 -5 37 -12 70 -14
158 -14 266 -26 276 -33 7 -4 55 -11 108 -16 114 -10 240 -23 376 -37 1062
-112 2605 -112 3660 0 133 14 259 26 376 37 53 5 101 12 106 15 10 7 144 23
278 34 33 2 64 9 70 14 5 5 30 9 56 9 26 0 59 4 73 10 14 5 61 14 103 21 43 6
106 15 141 20 34 5 90 13 125 18 60 8 133 23 208 42 20 5 47 9 59 9 13 0 37 4
54 9 17 5 67 17 111 26 44 9 94 21 111 26 17 5 44 9 60 9 17 0 34 4 39 9 6 5
28 11 50 14 22 3 69 13 105 22 36 9 83 19 105 22 22 3 44 9 50 14 5 5 23 9 40
9 17 0 35 4 40 8 6 5 46 16 90 26 44 10 88 22 97 27 10 5 29 9 43 9 14 0 33 4
43 9 26 14 118 41 141 41 11 0 23 5 26 10 3 6 19 10 36 10 16 0 37 4 47 9 32
16 87 33 120 38 18 3 35 9 38 14 3 5 18 9 33 9 15 0 31 4 36 8 6 5 51 21 100
36 50 16 98 32 107 37 10 5 24 9 33 9 13 0 65 20 107 41 10 5 26 9 36 9 10 0
22 3 26 7 6 7 45 22 126 49 25 8 53 19 62 24 10 6 24 10 31 10 7 0 37 11 65
25 29 14 56 25 62 25 6 0 18 4 28 9 19 11 70 32 122 51 19 7 39 17 45 22 5 4
15 8 22 8 11 0 101 38 145 61 10 5 25 9 33 9 8 0 15 5 15 10 0 6 6 10 12 10 7
0 35 11 63 24 214 103 354 170 376 182 15 8 46 24 70 36 24 13 46 26 47 31 2
4 10 7 18 7 8 0 31 10 52 23 20 13 44 26 52 30 8 4 33 18 55 32 22 14 47 28
55 32 8 4 38 22 67 40 29 18 57 33 63 33 5 0 10 5 10 10 0 6 5 10 12 10 6 0
26 11 44 25 18 14 36 25 40 25 3 0 35 20 70 45 34 25 67 45 73 45 6 0 11 4 11
8 0 4 15 16 33 26 29 17 215 152 227 166 3 3 30 24 61 47 31 23 62 47 70 55 8
8 32 27 53 43 22 17 81 69 130 116 50 47 118 110 152 140 33 30 70 68 83 84
12 17 57 68 101 115 44 47 80 88 80 92 0 3 6 13 13 20 40 43 227 300 227 313
0 3 11 24 26 46 65 103 184 345 184 374 0 8 5 17 10 20 6 3 10 15 10 25 0 11
7 36 16 57 27 61 32 76 39 108 3 17 10 46 14 65 5 19 14 62 20 95 6 33 16 78
21 100 10 44 23 216 23 310 0 137 -27 354 -62 500 -6 22 -13 54 -16 70 -4 17
-10 39 -15 50 -4 11 -13 34 -20 50 -6 17 -19 50 -27 75 -8 25 -24 65 -35 90
-11 25 -27 61 -35 80 -29 66 -85 171 -127 239 -15 22 -26 43 -26 46 0 12 -192
279 -220 305 -3 3 -18 23 -35 45 -70 94 -403 428 -505 506 -19 15 -44 35 -55
46 -11 10 -38 32 -60 48 -22 17 -42 32 -45 35 -3 4 -23 19 -45 35 -22 17 -42
32 -45 35 -23 24 -309 220 -321 220 -5 0 -9 4 -9 8 0 5 -10 14 -22 20 -13 6
-45 25 -73 42 -27 17 -60 36 -72 42 -13 6 -23 15 -23 20 0 4 -9 8 -20 8 -11 0
-20 5 -20 10 0 6 -5 10 -11 10 -6 0 -25 10 -42 22 -18 13 -54 35 -82 49 -27
15 -84 45 -125 67 -64 35 -297 152 -475 238 -28 13 -56 24 -63 24 -6 0 -12 5
-12 10 0 6 -6 10 -13 10 -7 0 -31 8 -53 19 -41 19 -105 47 -139 61 -11 4 -36
15 -57 24 -20 9 -41 16 -47 16 -6 0 -11 5 -11 10 0 6 -11 10 -24 10 -14 0 -28
5 -31 10 -3 6 -14 10 -23 10 -9 0 -39 12 -67 25 -27 14 -58 25 -67 25 -10 0
-18 5 -18 10 0 6 -9 10 -20 10 -11 0 -28 4 -38 9 -46 23 -95 41 -112 41 -10 0
-22 5 -25 10 -3 6 -14 10 -24 10 -16 0 -59 17 -103 41 -10 5 -25 9 -33 9 -8 0
-23 4 -33 9 -9 5 -37 14 -62 21 -25 7 -60 18 -78 26 -18 8 -39 14 -47 14 -9 0
-23 4 -33 9 -9 5 -57 21 -107 36 -49 15 -98 31 -107 36 -10 5 -27 9 -37 9 -11
0 -30 4 -43 9 -13 4 -50 16 -83 26 -33 9 -68 21 -77 26 -10 5 -31 9 -47 9 -17
0 -33 5 -36 10 -3 6 -17 10 -31 10 -27 0 -117 25 -146 41 -10 5 -33 9 -52 9
-19 0 -37 4 -40 9 -3 5 -23 11 -43 14 -52 7 -134 26 -158 37 -11 5 -36 11 -55
14 -43 6 -105 19 -190 41 -61 15 -91 21 -222 44 -29 5 -84 17 -123 26 -84 20
-130 27 -389 65 -44 6 -84 14 -89 17 -5 3 -39 10 -76 15 -36 5 -93 13 -126 18
-33 4 -95 13 -138 19 -42 5 -83 13 -89 17 -6 4 -54 11 -107 16 -53 5 -139 13
-191 18 -163 14 -293 29 -325 36 -46 10 -195 24 -360 34 -397 23 -503 30 -540
35 -35 5 -615 23 -955 30 -69 1 -152 -1 -185 -5z m1130 -272 c165 -11 368 -24
450 -28 183 -10 381 -26 392 -33 5 -3 51 -9 103 -12 52 -4 100 -10 105 -13 6
-4 57 -10 115 -15 242 -19 433 -41 453 -54 6 -4 41 -11 77 -15 36 -4 94 -12
130 -17 36 -5 101 -14 144 -21 44 -6 84 -14 90 -18 6 -4 38 -10 71 -14 139
-17 303 -46 319 -56 6 -3 35 -10 64 -14 96 -15 157 -26 222 -42 73 -19 133
-33 200 -46 120 -24 209 -46 245 -61 11 -4 34 -10 50 -13 58 -9 195 -46 217
-57 10 -5 27 -9 37 -9 11 0 30 -4 43 -9 13 -5 50 -17 83 -26 33 -10 68 -21 77
-26 10 -5 29 -9 43 -9 14 0 33 -4 43 -9 9 -5 45 -17 80 -27 35 -10 65 -21 68
-26 3 -4 16 -8 30 -8 13 0 32 -4 42 -9 9 -5 44 -17 77 -26 33 -10 64 -21 70
-26 5 -5 17 -9 27 -9 10 0 26 -4 36 -9 9 -5 42 -17 72 -26 30 -10 59 -22 65
-26 5 -5 19 -9 31 -9 13 0 26 -4 29 -10 3 -5 15 -10 26 -10 10 0 27 -4 37 -10
21 -11 76 -34 122 -50 33 -11 44 -16 115 -45 17 -7 44 -18 60 -25 17 -7 38
-16 47 -21 10 -5 22 -9 28 -9 9 0 81 -31 175 -76 28 -13 56 -24 63 -24 6 0 12
-4 12 -10 0 -5 7 -10 15 -10 8 0 23 -4 33 -9 83 -43 271 -131 280 -131 6 0 12
-3 14 -7 2 -5 41 -27 88 -51 47 -24 126 -65 175 -92 50 -27 97 -53 105 -57 8
-4 44 -25 80 -48 36 -22 82 -49 103 -60 20 -11 37 -23 37 -27 0 -5 7 -8 15 -8
8 0 15 -4 15 -10 0 -5 5 -10 11 -10 6 0 40 -20 75 -45 34 -25 65 -45 68 -45 9
0 151 -102 154 -112 2 -4 10 -8 18 -8 8 0 14 -3 14 -7 0 -5 17 -19 37 -33 20
-14 41 -29 47 -35 6 -5 36 -29 66 -51 30 -23 67 -52 81 -65 14 -13 43 -37 65
-54 78 -59 372 -363 475 -490 57 -71 136 -180 174 -240 39 -61 76 -120 83
-130 7 -11 15 -28 18 -37 4 -10 9 -18 13 -18 3 0 12 -15 20 -32 8 -18 29 -64
47 -103 17 -38 44 -104 59 -145 15 -41 30 -84 35 -95 5 -11 11 -31 14 -45 3
-14 12 -52 21 -85 48 -173 61 -520 28 -740 -11 -69 -50 -222 -64 -247 -5 -10
-9 -25 -9 -33 0 -8 -4 -23 -9 -33 -5 -9 -17 -37 -26 -62 -10 -25 -37 -87 -61
-138 -24 -51 -44 -95 -44 -97 0 -3 -16 -29 -35 -59 -19 -30 -35 -58 -35 -61 0
-4 -84 -130 -138 -204 -39 -55 -110 -143 -177 -220 -59 -69 -324 -330 -380
-376 -27 -22 -71 -60 -98 -84 -28 -23 -84 -68 -126 -99 -42 -31 -78 -59 -81
-62 -6 -9 -240 -170 -246 -170 -2 0 -26 -16 -53 -35 -26 -19 -53 -35 -59 -35
-6 0 -12 -3 -14 -7 -3 -9 -84 -63 -93 -63 -3 0 -29 -15 -58 -33 -29 -18 -68
-41 -87 -50 -19 -10 -51 -27 -70 -39 -19 -11 -84 -47 -145 -78 -60 -31 -127
-67 -148 -79 -21 -11 -42 -21 -48 -21 -5 0 -27 -11 -49 -25 -22 -14 -46 -25
-55 -25 -8 0 -15 -4 -15 -10 0 -5 -6 -10 -14 -10 -8 0 -36 -11 -63 -25 -43
-22 -140 -66 -218 -100 -16 -7 -46 -18 -65 -25 -19 -7 -58 -23 -87 -36 -28
-13 -57 -24 -63 -24 -5 0 -18 -4 -28 -9 -18 -9 -69 -31 -117 -51 -16 -7 -38
-16 -47 -21 -10 -5 -25 -9 -33 -9 -8 0 -23 -5 -33 -10 -9 -6 -60 -26 -112 -44
-125 -44 -191 -67 -215 -76 -21 -8 -210 -67 -340 -108 -44 -13 -90 -28 -103
-33 -13 -5 -33 -9 -45 -9 -13 0 -27 -4 -32 -9 -6 -4 -30 -14 -55 -20 -25 -7
-61 -17 -80 -22 -19 -6 -53 -14 -75 -19 -72 -16 -120 -28 -150 -38 -67 -23
-103 -32 -123 -32 -12 0 -30 -4 -40 -9 -18 -9 -88 -28 -162 -43 -89 -18 -136
-27 -187 -37 -29 -5 -57 -13 -63 -16 -5 -3 -36 -11 -67 -17 -32 -5 -80 -14
-108 -19 -27 -5 -75 -13 -107 -18 -31 -5 -61 -12 -67 -15 -13 -8 -86 -22 -191
-37 -99 -14 -164 -24 -285 -44 -127 -21 -203 -33 -285 -44 -36 -5 -76 -11 -90
-15 -32 -7 -314 -39 -500 -55 -52 -4 -102 -11 -110 -14 -30 -13 -318 -35 -725
-57 -187 -9 -979 -34 -1110 -34 -193 0 -739 15 -900 24 -93 6 -217 12 -275 15
-332 16 -645 41 -664 53 -6 3 -54 10 -106 14 -154 12 -440 45 -590 68 -30 5
-86 13 -125 19 -38 6 -110 18 -160 27 -49 9 -117 20 -150 24 -33 5 -94 13
-135 19 -104 15 -178 29 -190 36 -6 4 -39 11 -73 17 -34 5 -82 14 -107 18 -25
5 -71 13 -102 19 -31 5 -62 12 -67 16 -6 3 -35 11 -64 16 -53 10 -106 21 -187
37 -25 5 -72 17 -105 27 -33 10 -77 20 -98 22 -20 3 -40 9 -43 14 -3 5 -19 9
-35 9 -17 0 -40 5 -52 12 -24 12 -80 26 -140 35 -20 3 -40 9 -43 14 -3 5 -14
9 -25 9 -23 0 -115 27 -141 41 -10 5 -27 9 -37 9 -11 0 -30 4 -43 9 -13 5 -63
21 -113 36 -141 43 -238 75 -257 86 -10 5 -27 9 -38 9 -11 0 -28 4 -38 9 -9 4
-39 16 -67 26 -198 69 -242 85 -257 95 -10 5 -25 10 -33 10 -8 0 -23 4 -33 9
-9 5 -30 14 -47 21 -48 20 -99 42 -117 51 -10 5 -23 9 -28 9 -6 0 -35 11 -63
24 -29 13 -79 34 -112 46 -33 13 -80 33 -105 45 -25 12 -56 27 -70 32 -14 6
-50 22 -80 37 -30 14 -60 26 -67 26 -6 0 -13 3 -15 8 -4 9 -110 62 -126 62 -6
0 -12 5 -12 10 0 6 -7 10 -15 10 -9 0 -32 10 -53 23 -20 13 -62 35 -92 51 -30
15 -86 45 -125 66 -38 21 -86 46 -105 56 -19 10 -48 27 -65 38 -34 24 -71 45
-132 77 -24 13 -43 26 -43 31 0 4 -4 8 -10 8 -8 0 -139 85 -191 123 -8 7 -26
18 -40 26 -26 15 -206 148 -227 168 -7 7 -16 13 -20 13 -4 0 -20 12 -37 28
-16 15 -59 52 -95 82 -173 147 -405 378 -505 505 -22 28 -47 58 -56 68 -28 30
-174 248 -213 317 -91 162 -168 339 -206 475 -5 17 -16 57 -25 90 -31 109 -38
187 -38 425 -1 243 3 293 29 395 31 120 37 141 56 195 10 30 26 75 34 100 38
109 161 340 251 467 23 34 43 66 43 71 0 6 4 12 8 14 4 2 43 48 87 103 44 55
102 125 130 155 61 67 294 298 326 324 35 28 141 118 164 139 11 10 32 26 48
35 15 9 27 20 27 24 0 4 7 8 15 8 8 0 15 3 15 8 0 4 17 18 37 32 20 14 57 42
82 63 25 20 51 37 57 37 7 0 14 3 16 8 2 4 50 38 108 76 58 38 117 77 132 88
15 10 32 18 38 18 5 0 10 5 10 10 0 6 4 10 10 10 5 0 34 16 63 34 56 36 99 61
222 128 74 40 506 254 540 268 11 4 49 22 85 38 137 64 202 92 211 92 5 0 17
4 27 9 9 5 31 14 47 21 48 20 99 42 117 51 10 5 25 9 33 9 8 0 23 4 33 9 30
16 85 38 152 61 36 12 79 28 97 36 17 8 38 14 46 14 9 0 19 5 22 10 3 6 17 10
30 10 13 0 27 5 30 10 3 6 19 10 35 10 16 0 31 4 34 9 4 5 32 17 64 26 31 9
65 21 74 26 10 5 28 9 41 9 13 0 27 4 32 9 6 5 37 16 70 26 33 9 70 21 83 26
13 5 34 9 47 9 13 0 27 5 30 10 3 6 18 10 33 10 15 1 38 7 52 15 14 8 37 14
52 15 15 0 29 4 32 9 3 5 20 11 38 14 18 2 58 12 88 21 30 9 72 19 93 23 21 3
40 10 43 14 3 5 18 9 35 9 16 0 37 4 47 9 33 17 205 57 337 79 28 4 55 11 62
15 18 12 134 35 270 55 33 5 66 13 73 17 6 4 37 11 68 16 120 21 179 30 243
38 36 4 71 11 77 15 6 3 44 11 84 17 153 23 205 30 268 37 36 4 70 10 76 14
18 12 163 30 459 57 50 5 149 16 220 25 190 25 320 36 495 45 85 5 218 13 295
20 299 25 432 28 1080 29 583 1 709 -1 970 -20z"/>
<path d="M10135 18385 c-97 -13 -144 -26 -240 -65 -46 -18 -156 -94 -199 -137
-74 -73 -140 -186 -174 -298 -27 -84 -40 -1253 -25 -2180 l8 -470 305 0 305 0
5 485 c3 267 9 491 13 498 6 9 74 12 282 12 261 0 275 -1 285 -19 6 -13 10
-188 10 -500 l0 -481 308 2 307 3 0 1580 0 1580 -550 1 c-388 1 -577 -2 -640
-11z m565 -521 c6 -15 10 -243 10 -579 0 -490 -2 -555 -16 -569 -13 -14 -52
-16 -275 -16 -160 0 -268 4 -280 10 -18 10 -19 26 -19 440 0 460 6 541 47 626
43 91 107 111 371 113 l152 1 10 -26z"/>
<path d="M11685 18388 c-3 -7 -4 -719 -3 -1583 l3 -1570 739 -3 c407 -1 744 2
748 6 5 5 4 74 -3 153 -6 79 -15 216 -20 304 -13 242 -29 518 -37 630 l-7 100
-32 3 c-18 2 -103 -4 -190 -12 -86 -9 -183 -16 -215 -16 l-58 0 0 -345 0 -346
-152 3 -153 3 -5 1340 -5 1340 -303 3 c-237 2 -304 0 -307 -10z"/>
<path d="M13347 18393 c-4 -3 -7 -377 -7 -830 0 -549 -3 -831 -10 -844 -10
-17 -22 -19 -110 -19 -76 0 -100 -3 -100 -13 0 -12 37 -99 60 -139 6 -10 10
-26 10 -37 0 -11 4 -21 8 -23 5 -1 32 -61 62 -133 29 -71 58 -136 64 -144 7
-10 13 -168 16 -495 l5 -481 308 -3 307 -2 0 481 c0 312 4 487 10 500 10 18
24 19 284 19 217 0 276 -3 285 -13 7 -10 12 -161 13 -498 l3 -484 308 -3 307
-2 0 1585 0 1585 -307 -2 -308 -3 -3 -834 c-1 -596 -5 -838 -13 -848 -9 -10
-67 -13 -278 -13 -150 0 -273 4 -281 10 -13 8 -15 115 -18 850 l-2 840 -304 0
c-166 0 -306 -3 -309 -7z"/>
<path d="M16153 18384 c-51 -7 -101 -18 -112 -24 -11 -5 -28 -10 -38 -10 -50
0 -229 -112 -291 -182 -57 -63 -107 -140 -129 -198 -55 -142 -53 -119 -53
-699 0 -477 -2 -541 -16 -555 -12 -12 -38 -16 -115 -16 -54 0 -99 -4 -99 -8 0
-5 8 -26 19 -48 25 -53 46 -102 62 -144 7 -19 28 -66 46 -104 18 -38 33 -73
33 -77 0 -8 42 -106 61 -141 5 -10 9 -221 9 -483 l0 -465 308 2 307 3 3 484
c1 337 6 488 13 498 9 10 69 13 285 13 l274 0 10 -26 c6 -15 10 -216 10 -500
l0 -474 308 2 307 3 0 1580 0 1580 -555 1 c-420 2 -577 -1 -647 -12z m579
-531 c5 -18 7 -280 6 -583 -3 -477 -5 -552 -18 -560 -21 -13 -526 -13 -551 0
-18 10 -19 26 -19 440 0 407 9 572 31 595 5 5 9 16 9 25 1 22 32 56 75 80 52
29 125 38 304 36 l155 -1 8 -32z"/>
<path d="M17710 16815 l0 -1585 744 0 c410 0 746 3 748 8 2 4 0 66 -4 137 -4
72 -12 211 -18 310 -24 435 -28 497 -40 615 -7 69 -14 127 -16 129 -3 3 -89
-3 -192 -12 -103 -10 -211 -17 -239 -17 l-53 0 0 -345 0 -345 -150 0 c-111 0
-152 3 -155 13 -3 6 -6 611 -7 1342 l-3 1330 -307 3 -308 2 0 -1585z"/>
<path d="M20002 18384 c-51 -7 -101 -18 -112 -24 -10 -5 -26 -10 -34 -10 -49
0 -243 -120 -298 -183 -50 -59 -107 -148 -125 -197 -55 -145 -53 -119 -53
-699 0 -477 -2 -541 -16 -555 -12 -12 -38 -16 -115 -16 -63 0 -99 -4 -99 -11
0 -5 16 -45 36 -87 20 -42 40 -86 44 -97 4 -11 15 -36 23 -55 54 -122 91 -211
108 -255 18 -46 19 -82 19 -508 l0 -457 308 2 307 3 3 484 c1 337 6 488 13
498 16 18 554 19 566 1 4 -7 10 -231 13 -498 l5 -485 305 0 305 0 0 1580 0
1580 -555 1 c-420 1 -578 -2 -648 -12z m578 -520 c7 -17 9 -230 8 -586 -3
-484 -5 -560 -18 -568 -21 -13 -526 -13 -551 0 -18 10 -19 26 -19 446 0 414 8
564 31 589 5 5 9 16 9 25 0 20 43 66 81 85 44 23 126 32 297 34 l152 1 10 -26z"/>
<path d="M21562 16818 l3 -1583 744 -3 743 -2 -6 152 c-20 440 -60 1035 -71
1047 -3 2 -92 -3 -198 -12 -105 -10 -213 -17 -239 -17 l-48 0 -2 -342 -3 -343
-150 0 -150 0 -5 1340 -5 1340 -308 3 -307 2 2 -1582z"/>
<path d="M13110 14170 l0 -581 368 4 c421 5 469 10 572 59 51 24 114 101 135
163 10 33 23 66 29 73 15 20 13 549 -2 564 -7 7 -12 20 -12 30 0 25 -51 130
-71 148 -62 54 -103 80 -127 80 -10 0 -22 3 -26 8 -20 19 -214 31 -528 31
l-338 1 0 -580z m694 324 c16 -4 46 -24 66 -44 46 -46 54 -91 54 -280 -1 -184
-9 -231 -48 -276 -40 -46 -75 -53 -297 -53 -165 -1 -167 -1 -173 22 -11 42 -7
607 5 629 11 20 16 21 188 15 97 -4 189 -10 205 -13z"/>
<path d="M15336 14698 c-10 -29 -21 -62 -26 -73 -4 -11 -20 -60 -36 -110 -15
-49 -32 -94 -36 -99 -4 -6 -8 -22 -8 -36 0 -14 -4 -30 -8 -36 -4 -5 -16 -36
-27 -69 -10 -33 -22 -64 -27 -69 -4 -6 -8 -20 -8 -33 0 -13 -4 -31 -9 -41 -5
-9 -17 -42 -26 -72 -10 -30 -22 -59 -26 -64 -5 -6 -9 -20 -9 -33 0 -13 -4 -31
-9 -41 -5 -9 -21 -57 -37 -107 -15 -49 -31 -94 -34 -100 -4 -5 -10 -21 -13
-35 -3 -14 -10 -40 -15 -57 l-11 -33 155 0 154 0 15 36 c8 20 15 47 15 60 0
12 5 26 10 29 6 3 10 15 10 26 0 11 7 33 15 49 l16 30 233 0 233 0 17 -43 c9
-23 16 -52 16 -64 0 -12 5 -25 10 -28 6 -3 10 -21 10 -39 0 -53 9 -56 186 -56
l162 0 -10 33 c-6 17 -15 40 -19 49 -5 10 -9 29 -9 42 0 14 -4 27 -9 30 -5 3
-11 18 -14 33 -5 30 -24 87 -38 115 -5 10 -9 28 -9 41 0 13 -4 27 -8 33 -4 5
-16 36 -26 69 -10 33 -22 68 -27 77 -5 10 -9 27 -9 38 0 11 -4 28 -10 38 -16
29 -60 167 -60 190 0 11 -4 24 -10 27 -5 3 -10 16 -10 29 0 12 -3 26 -6 29
-11 11 -43 111 -44 135 0 12 -4 22 -10 22 -5 0 -10 13 -10 29 0 17 -4 32 -9
36 -5 3 -12 19 -16 35 l-7 30 -252 0 -252 0 -18 -52z m298 -250 c9 -35 22 -71
27 -80 5 -10 9 -27 9 -38 0 -11 4 -28 10 -38 16 -28 59 -165 62 -197 l3 -30
-150 0 -150 0 3 35 c2 19 8 39 13 45 5 5 9 21 9 36 0 15 4 30 9 33 5 3 11 18
14 33 5 30 24 87 38 115 5 10 9 27 9 37 0 11 5 23 10 26 6 3 10 15 10 26 0 31
19 59 38 59 14 0 23 -16 36 -62z"/>
<path d="M16802 14633 l3 -118 165 -3 c141 -2 167 -5 178 -19 9 -13 12 -121
12 -460 l0 -443 140 0 140 0 0 440 c0 427 1 441 20 460 18 18 33 20 185 20
l165 0 0 120 0 120 -505 0 -506 0 3 -117z"/>
<path d="M18730 14730 c0 -11 -4 -28 -9 -38 -5 -9 -17 -43 -26 -74 -9 -32 -21
-60 -26 -64 -5 -3 -9 -16 -9 -30 0 -13 -4 -32 -9 -42 -5 -9 -21 -57 -37 -107
-15 -49 -31 -97 -35 -105 -4 -8 -24 -69 -44 -135 -21 -66 -41 -129 -45 -140
-5 -11 -16 -45 -26 -75 -9 -30 -20 -64 -24 -75 -4 -11 -20 -60 -36 -110 -15
-49 -32 -94 -36 -100 -4 -5 -8 -17 -8 -27 0 -17 12 -18 153 -18 l153 0 29 88
c15 48 33 99 39 115 l11 27 232 0 232 0 15 -32 c9 -17 16 -42 16 -55 0 -13 4
-31 10 -41 5 -9 14 -36 20 -59 l11 -43 169 0 c159 0 170 1 161 18 -16 28 -61
167 -61 185 0 10 -4 25 -9 35 -17 33 -54 147 -59 180 -2 18 -8 35 -13 38 -5 3
-9 14 -9 25 0 10 -4 27 -9 37 -11 20 -33 87 -51 152 -6 25 -15 52 -19 60 -4 8
-16 42 -25 75 -10 33 -22 68 -27 77 -5 10 -9 27 -9 38 0 11 -4 28 -9 38 -14
28 -33 85 -38 115 -3 15 -9 30 -14 33 -5 3 -9 16 -9 30 l0 24 -260 0 c-254 0
-260 0 -260 -20z m278 -245 c2 -11 7 -29 11 -40 5 -11 21 -60 36 -110 15 -49
31 -99 35 -110 21 -54 39 -113 42 -135 l3 -25 -152 -3 -153 -3 0 28 c0 24 14
71 40 138 4 11 20 61 36 110 15 50 31 97 35 105 4 8 10 28 14 43 4 22 11 28
28 25 13 -2 23 -11 25 -23z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
